import Entity from '../../schema/Entity';
import EntityType from '../../schema/innerSchema/EntityType';
import EntityTypeNames from '../../schema/innerSchema/EntityTypeNames';
import RentalCarReservation from '../../schema/RentalCarReservation';
import assignCar from './assignCar';
import assignPlace from './assignPlace';
import setReservationEntityData from './setReservationEntityData';
import tryCreateTxpOwaDate from './tryCreateTxpOwaDate';

/**
 * parse data for Rental Car Entity
 */
export default function setRentalCarEntityData(
    entity: Entity,
    rentalCarEntity: any
): RentalCarReservation {
    if (entity && rentalCarEntity && isRentalCarEntityValid(rentalCarEntity, entity)) {
        let newRentalCarEntity: RentalCarReservation = setReservationEntityData(
            entity,
            rentalCarEntity,
            true /* isReservationIdRequired */
        );
        newRentalCarEntity = {
            ...newRentalCarEntity,
            ...{
                entityName: EntityTypeNames.RentalCarReservation,
                entityType: EntityType.RentalCarReservation,
                pickupTime: rentalCarEntity.pickupTime,
                pickupTimeUTC: rentalCarEntity['pickupTime/utc'],
                dropoffTime: rentalCarEntity.dropoffTime,
                dropoffTimeUTC: rentalCarEntity['dropoffTime/utc'],
                car: assignCar(newRentalCarEntity, rentalCarEntity.reservationFor),
                dropoffLocation: assignPlace(newRentalCarEntity, rentalCarEntity.dropoffLocation),
                pickupLocation: assignPlace(newRentalCarEntity, rentalCarEntity.pickupLocation),
                provider: rentalCarEntity.provider,
            },
        };
        return newRentalCarEntity as RentalCarReservation;
    }
    return null;
}

function isRentalCarEntityValid(rentalCarEntity: any, entity: Entity) {
    if (
        rentalCarEntity.reservationFor &&
        rentalCarEntity.dropoffLocation &&
        rentalCarEntity.pickupLocation &&
        rentalCarEntity.pickupTime &&
        tryCreateTxpOwaDate(rentalCarEntity.pickupTime, entity) &&
        rentalCarEntity.dropoffTime &&
        tryCreateTxpOwaDate(rentalCarEntity.dropoffTime, entity)
    ) {
        return true;
    }
    return false;
}
